import { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { addScore, readScores } from "../../redux/index";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import DigitalDisplay from "./DigitalDisplay";
import Board from "./Board";
import Button from "@mui/material/Button";
import SomuraSelectField from "../SomuraSelectField";
import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import LogoutIcon from "@mui/icons-material/Logout";

const mapStateToProps = (state) => {
  return {
    loggedUserId: state.loggeduser.LoggedUser.id,
    score: state.general.Scores,
    persons: state.persons.PersonsMin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addScore: (values) => dispatch(addScore(values)),
    readScores: (values) => dispatch(readScores(values)),
  };
};

const MineSweeper = ({
  closeGame,
  loggedUserId,
  score,
  persons,
  addScore,
  readScores,
}) => {
  const secondsRef = useRef();
  const seconds = useRef();
  const [displaySeconds, setDisplaySeconds] = useState(0);
  const [openScore, setOpenScore] = useState(false);

  const levels = [
    {
      height: 10,
      width: 10,
      mines: 10,
      gameStatus: 0,
      name: "Beginner",
    },
    {
      height: 16,
      width: 16,
      mines: 40,
      gameStatus: 0,
      name: "Advanced",
    },
    {
      height: 16,
      width: 30,
      mines: 10,
      gameStatus: 0,
      name: "Professional",
    },
  ];

  var levelOptions = levels.map((L, index) => ({
    label: L.name,
    value: index,
  }));
  levelOptions.unshift({ label: "All levels", value: 99 });
  const [scoreLevel, setScoreLevel] = useState(99);

  const List = score?.map((S, index) => (
    <>
      <Box sx={{ gridColumn: 1 }}>{index + 1}</Box>
      <Box
        sx={{
          gridColumn: 2,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {persons.find((P) => P.id === S.userId).listName}
      </Box>
      <Box sx={{ gridColumn: 3, textAlign: "center" }}>{S.level}</Box>
      <Box sx={{ gridColumn: 4, textAlign: "center" }}>{S.mines}</Box>
      <Box sx={{ gridColumn: 5, textAlign: "center" }}>{S.seconds}</Box>
      <Box sx={{ gridColumn: 6, textAlign: "center" }}>{S.clicks}</Box>
      <Box sx={{ gridColumn: 7, textAlign: "center" }}>{S.points}</Box>
    </>
  ));

  const [state, setState] = useState({
    ...levels[0],
    level: 0,
    leftMines: levels[0].mines,
    timeRunning: false,
    grid: [],
    minesCount: levels[0].mines,
    gameStatus: 0,
    revealedCells: 0,
    clicks: 0,
  });

  const restartGame = () => {
    // Restart the Game
    if (state.timeRunning === false) {
      seconds.current = 0;
      setState({
        ...levels[state.level],
        leftMines: levels[state.level].mines,
        message: "Game running",
        timeRunning: true,
      });
      setDisplaySeconds(0);
    }
  };

  const setSeconds = () => {
    if (state.timeRunning === true) {
      if (seconds.current === 999) {
        setState({ ...state, gameStatus: 30, timeRunning: false });
      } else {
        seconds.current = seconds.current + 1;
        setDisplaySeconds(seconds.current);
      }
    }
  };

  const handleButtonClick = () => {
    seconds.current = 0;
    setState({
      ...state,
      leftMines: levels[state.level].mines,
      gameStatus: 0,
      timeRunning: false,
      grid: [],
    });
    setDisplaySeconds(0);
  };

  const handleLevelClick = () => {
    if (!openScore) {
      seconds.current = 0;
      var nextLevel;
      switch (state.level) {
        case 0:
          nextLevel = 1;
          break;
        case 1:
          nextLevel = 2;
          break;
        case 2:
          nextLevel = 0;
          break;
        default:
      }
      setState({
        ...levels[nextLevel],
        level: nextLevel,
        leftMines: levels[nextLevel].mines,
        timeRunning: false,
        grid: [],
      });
      setDisplaySeconds(0);
    }
  };

  const handleScoreClick = () => {
    setOpenScore(!openScore);
  };

  const handleScoreChange = (e) => {
    const value = e.target.value;
    setScoreLevel(value);
    readScores({ level: value });
  };

  useEffect(() => {
    readScores({ level: 99 });
    seconds.current = 0;
    setState({
      ...levels[0],
      level: 0,
      leftMines: levels[0].mines,
      timeRunning: false,
      grid: [],
      minesCount: levels[0].mines,
      gameStatus: 0,
      revealedCells: 0,
    });
    setDisplaySeconds(0);
    return () => {
      clearInterval(secondsRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    var text = "";
    switch (state.gameStatus) {
      case 0:
        text = (
          <Box>
            <Box sx={{ color: "#0E94F7", fontWeight: "bold" }}>
              LEVEL '{levels[state.level].name}'
            </Box>
            <Box>Click on a cell to start the game</Box>
          </Box>
        );
        break;
      case 1:
        text = "Game running";
        restartGame();
        break;
      case 10:
        text = (
          <Box>
            <Box sx={{ color: "#0AE915", fontWeight: "bold" }}>
              GAME SOLVED - GOOD JOB!
            </Box>
            <Box>Click on emoji to load new board</Box>
          </Box>
        );
        addScore({
          userId: loggedUserId,
          level: state.level,
          mines: state.mines,
          seconds: seconds.current,
          clicks: state.clicks,
          points: 55,
        });
        break;
      case 20:
        text = (
          <Box>
            <Box sx={{ color: "red", fontWeight: "bold" }}>GAME LOST</Box>
            <Box>Click on emoji to load new board</Box>
          </Box>
        );
        break;
      case 30:
        text = (
          <Box>
            <Box sx={{ color: "red", fontWeight: "bold" }}>
              TIME EXPIRED - GAME LOST
            </Box>
            <Box>Click on emoji to load new board</Box>
          </Box>
        );
        break;
      default:
    }
    setState({ ...state, message: text });
    // eslint-disable-next-line
  }, [state.gameStatus, state.level]);

  useEffect(() => {
    if (state.timeRunning === true) {
      secondsRef.current = setInterval(() => {
        setSeconds();
      }, 1000);
    } else {
      clearInterval(secondsRef.current);
    }
    // eslint-disable-next-line
  }, [state.timeRunning]);

  return (
    <Box>
      <Box
        sx={{
          padding: "0.5rem",
          margin: "auto",
          backgroundColor: "#444C54",
          border: "4px outset #788088",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Box>
            <Collapse in={!openScore} timeout={"auto"}>
              <Box
                sx={{
                  height: "3rem",
                  padding: "0.1rem",
                  border: "4px inset #788088",
                }}
              >
                <Grid container>
                  <Grid size={3}>
                    <DigitalDisplay number={state.leftMines} />
                  </Grid>
                  {/* This is to suppress permanent reload of images */}
                  <DigitalDisplay hidden={true} number={1234567890} />
                  <Grid
                    size={6}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <Box sx={{ marginTop: "-6px" }}>
                      <Button
                        sx={{
                          minWidth: "0",
                          height: "2.2rem",
                          border: "4px outset #788088",
                        }}
                        onClick={handleButtonClick}
                      >
                        <img
                          style={{
                            width: "1.2rem",
                          }}
                          sx={{
                            animation: "growing 4s linear infinite",
                            "@keyframes growing": {
                              "0%": { transform: "scale(1)" },
                              "10%": { transform: "scale(2)" },
                              "20%": { transform: "scale(1)" },
                              "30%": { transform: "scale(0.5)" },
                              "40%": { transform: "scale(1)" },
                            },
                          }}
                          src={
                            state.gameStatus === 10
                              ? "/images/game/happy-face.png"
                              : state.gameStatus >= 20
                              ? "/images/game/shocked.png"
                              : "/images/game/smile.png"
                          }
                          alt=""
                        />
                      </Button>
                    </Box>
                  </Grid>
                  <Grid
                    size={3}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <DigitalDisplay number={displaySeconds} />
                  </Grid>
                </Grid>
              </Box>
              <Box
                sx={{
                  marginTop: "0.5rem",
                  border: "4px inset #788088",
                }}
              >
                <Board
                  state={state}
                  updateState={(values) => setState(values)}
                />
              </Box>
            </Collapse>
            <Collapse in={openScore} timeout={"auto"}>
              {openScore && (
                <>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "80% 20%",
                      height: "3.3rem",
                      padding: "0.1rem",
                      border: "4px inset #788088",
                      color: "#EFB60C",
                    }}
                  >
                    <Box
                      sx={{
                        gridColumn: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        lineHeight: "1.1rem",
                        fontSize: "1rem",
                      }}
                    >
                      Ranking list
                    </Box>
                    <SomuraSelectField
                      sx={{
                        gridColumn: 2,
                        width: "9rem",
                        height: "2.5rem",
                        border: "none !important",
                        borderRadius: "4px",
                        boxShadow: "inset 1px 1px 3px 1px rgba(0, 0, 0, 0.8)",
                        color: "white",
                      }}
                      options={levelOptions}
                      defaultValue={99}
                      value={scoreLevel}
                      onChange={handleScoreChange}
                      size="small"
                    />
                  </Box>
                  <Box
                    sx={{
                      height: "23rem",
                      width: "46rem",
                      padding: "0.1rem",
                      border: "4px inset #788088",
                    }}
                  >
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns:
                          "4rem 1fr 4rem 4rem 5rem 4rem 5rem",
                      }}
                    >
                      <Box sx={{ gridColumn: 1, backgroundColor: "#373737" }}>
                        Rank
                      </Box>
                      <Box sx={{ gridColumn: 2, backgroundColor: "#373737" }}>
                        Name
                      </Box>
                      <Box
                        sx={{
                          gridColumn: 3,
                          backgroundColor: "#373737",
                          textAlign: "center",
                        }}
                      >
                        Level
                      </Box>
                      <Box
                        sx={{
                          gridColumn: 4,
                          backgroundColor: "#373737",
                          textAlign: "center",
                        }}
                      >
                        Mines
                      </Box>
                      <Box
                        sx={{
                          gridColumn: 5,
                          backgroundColor: "#373737",
                          textAlign: "center",
                        }}
                      >
                        Seconds
                      </Box>
                      <Box
                        sx={{
                          gridColumn: 6,
                          backgroundColor: "#373737",
                          textAlign: "center",
                        }}
                      >
                        Clicks
                      </Box>
                      <Box
                        sx={{
                          gridColumn: 7,
                          backgroundColor: "#373737",
                          textAlign: "center",
                        }}
                      >
                        Points
                      </Box>
                      {List}
                    </Box>
                  </Box>
                </>
              )}
            </Collapse>
          </Box>
          <Box
            sx={{
              width: "3rem",
              padding: "0.1rem",
              marginLeft: "0.5rem",
              border: "4px inset #788088",
              display: "grid",
              gridTemplateColumns: "1fr",
              gridTemplateRows: "repeat(7, 2.25rem) 1fr",
            }}
          >
            <Box
              sx={{
                width: "2.2rem",
                height: "2.2rem",
                border: "4px outset #788088",
                color: openScore ? "grey" : "white",
                cursor: openScore ? "standard" : "pointer",
                gridRow: 1,
              }}
              onClick={handleLevelClick}
            >
              <AutoGraphOutlinedIcon />
            </Box>
            <Box
              sx={{
                width: "2.2rem",
                height: "2.2rem",
                marginTop: "4px",
                border: "4px outset #788088",
                cursor: "pointer",
                gridRow: 2,
              }}
              onClick={handleScoreClick}
            >
              <FormatListNumberedIcon />
            </Box>
            <Box
              sx={{
                width: "2.2rem",
                height: "2.2rem",
                marginTop: "4px",
                border: "4px outset #788088",
                cursor: "pointer",
                gridRow: 8,
                alignSelf: "end",
              }}
              onClick={closeGame}
            >
              <LogoutIcon />
            </Box>
          </Box>
        </Box>
        {!openScore && (
          <Box>
            <Box
              sx={{
                display: "flex",
                height: "3rem",
                marginTop: "0.5rem",
                padding: "0.1rem",
                border: "4px inset #788088",
                color: "#EFB60C",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                lineHeight: "1.1rem",
                fontSize: "1rem",
              }}
            >
              {state.message}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(MineSweeper);
